import * as React from "react"

interface BeeBufferProps extends React.SVGProps<SVGSVGElement> {
    wingsColor?: string;
    bodyColor?: string;
    width?: any;
    height?: any;
}

const BeeBuffer: React.FC<BeeBufferProps> = ({ wingsColor, bodyColor, width, height, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 375 375"
        {...props}
        fill=""
    >
        <animateTransform
            attributeName="transform"
            type="translate"
            from="0 0"
            to="0 -10"
            dur="0.5s"
            repeatCount="indefinite"
            keyTimes="0; 0.5; 1"
            values="0 0; 0 -10; 0 0"
        />
        <defs>
            <clipPath id="a">
                <path d="M138.594 189.637h80.894v58.605h-80.894Zm0 0" />
            </clipPath>
            <clipPath id="b">
                <path d="M143.582 200.195h35.184v48.047h-35.184Zm0 0" />
            </clipPath>
            <clipPath id="c">
                <path d="M182 152h72.95v64H182Zm0 0" />
            </clipPath>
            <clipPath id="d">
                <path d="M191.957 131.402h4.738v4.739h-4.738Zm0 0" />
            </clipPath>
            <clipPath id="e">
                <path d="M194.324 131.402a2.369 2.369 0 1 0 .004 4.738 2.369 2.369 0 0 0-.004-4.738Zm0 0" />
            </clipPath>
        </defs>
        <path
            fill={wingsColor}
            stroke="black" 
            strokeWidth="2"
            d="m179.973 198.953-1.137-1.02c-7.926-7.113-16.121-14.472-21.649-23.578-2.847-4.695-4.828-10.37-5.289-15.175-.277-2.88-.027-5.426.743-7.575.855-2.37 2.363-4.27 4.484-5.64a12.563 12.563 0 0 1 4.95-1.871c1.671-.258 3.456-.203 5.296.16 2.602.516 5.29 1.652 7.774 3.289 2.39 1.57 4.492 3.523 6.082 5.652 2.394 3.203 3.863 7.203 4.496 12.223.562 4.457.402 9.023.175 13.695-.117 2.371-.378 5.93-.968 9.387-.664 3.89-1.582 6.762-2.723 8.531-.676 1.055-1.43 1.7-2.234 1.922"
        >
            <animateTransform
                attributeName="transform"
                attributeType="XML"
                type="rotate"
                from="0 180 200"
                to="20 180 200"
                dur="0.3s"
                repeatCount="indefinite"
            />
        </path>
        {/* <g clipPath="url(#a)">
            <path d="M219.148 219.18a23.845 23.845 0 0 1-.593 3.476l-.016.063c-.644 2.562-1.73 5.008-3.23 7.289-.223.34-.457.676-.696 1008-2.613 3.586-5.96 6.683-9.976 9.234-.649.41-1.313.805-1.992 1.188-2.57 1.44-5.364 2.667-8.348 3.667a57.354 57.354 0 0 1-6.465 1.743 65.297 65.297 0 0 1-10.762 1.332c-3.422.144-7.879.086-12.574-.63-2.77-.421-5.621-1.073-8.394-2.046-3.707-1.297-6.895-3.055-9.477-5.223-2.96-2.48-5.152-5.52-6.52-9.035a19.293 19.293 0 0 1-.867-2.871 20.63 20.63 0 0 1-.316-6.723c.258-2.28.875-4.609 1.836-6.918.785-1.89 1.789-3.75 3-5.566 1.808-2.715 4.086-5.344 6.808-7.856.325-.3.653-.593.98-.878a46.259 46.259 0 0 1 6.388-4.715 41.747 41.747 0 0 1 7.84-3.742 40.945 40.945 0 0 1 4.246-1.239c.292-.07.585-.136.878-.199a42.653 42.653 0 0 1 6.926-.86c7.926-.34 16.422 1.423 25.352 5.266 4.11 1.77 7.508 4.012 10.105 6.664 3.14 3.203 5.047 6.946 5.672 11.125.145.977.238 1.942.281 2.899a25.45 25.45 0 0 1-.086 3.547" />
        </g> */}
        <path
            fill={bodyColor}
            d="M212.754 229.656c-.242.332-.492.66-.746.98-8.2 10.38-22.266 14.708-35.031 15.239-7.145.3-15.766-.45-22.809-3.621a27.427 27.427 0 0 1-3.617-1.945c-3.653-2.336-6.613-5.551-8.305-9.903-.32-.82-.57-1.664-.762-2.527-1.664-7.64 1.84-16.754 10.641-24.871 15.422-14.223 33.691-13.028 50.145-5.942 6.96 2.996 13.226 8.086 14.41 16.008.113.77.191 1.524.238 2.266.34 5.597-1.277 10.351-4.164 14.316"
        />
        <path d="m143.188 234.074-15.465 5.61c-.496.257-.364 1.093.175 1.109l21.786-.828-6.496-5.89" />
        <g clipPath="url(#b)">
            <path d="M178.578 248.102c-.504.03-1.004.058-1.508.078-3.422.144-7.879.086-12.574-.63-7.457-6.632-13.68-15.183-17.105-23.667-1.953-4.84-3.164-9.82-3.633-14.715 1.808-2.715 4.086-5.344 6.808-7.856.325-.3.653-.593.98-.878-.73 6.484.294 13.636 3.071 20.511 3.547 8.785 10.57 17.68 18.79 23.801a45.862 45.862 0 0 0 5.171 3.356" />
        </g>
        <path d="M204.637 240.25c-.649.41-1.313.805-1.992 1.188-2.57 1.44-5.364 2.667-8.348 3.664a55.734 55.734 0 0 1-4.277-2.086c-10.22-5.52-19.583-14.403-25.047-23.766-4.383-7.504-6.778-15.707-7.04-23.531a41.632 41.632 0 0 1 7.84-3.742c-.527 7.488 1.52 15.773 5.926 23.324 4.774 8.176 13.004 15.965 22.02 20.832 3.773 2.035 7.511 3.445 10.918 4.117M218.555 222.656l-.016.063c-.644 2.562-1.73 5.008-3.23 7.289a57.497 57.497 0 0 1-4.211-1.043c-11.157-3.215-22.192-9.899-29.52-17.88-5.574-6.077-9.535-13.151-11.558-20.347a42.227 42.227 0 0 1 7.805-1.059c1.773 5.65 5.015 11.231 9.491 16.11 6.399 6.973 16.094 12.824 25.934 15.66 1.809.52 3.586.926 5.305 1.207" />
        <path
            fill={wingsColor}
            stroke="black"   // Adds the black outline
            strokeWidth="2"
            d="M179.25 200.512a1.956 1.956 0 0 1-2.305 1.383l-.375-.083c-12.187-2.703-24.789-5.5-35.66-11.628-5.61-3.16-10.887-7.825-14.117-12.473-1.934-2.781-3.137-5.531-3.578-8.172-.488-2.918-.035-5.73 1.351-8.355a14.775 14.775 0 0 1 3.985-4.77c1.566-1.226 3.418-2.2 5.512-2.887 2.953-.972 6.355-1.359 9.835-1.125 3.344.23 6.614 1.016 9.461 2.278 4.286 1.898 8.082 5.136 11.61 9.906 3.129 4.238 5.586 8.992 8.031 13.906 1.242 2.492 3.016 6.281 4.39 10.16 1.551 4.36 2.262 7.825 2.11 10.293a7.304 7.304 0 0 1-.25 1.567"
        >
            <animateTransform
                attributeName="transform"
                attributeType="XML"
                type="rotate"
                from="0 180 200"
                to="-20 180 200"
                dur="0.3s"
                repeatCount="indefinite"
            />
        </path>
        <path fill="#050000" d="m216.93 215.57-.012-.23.012.23" />
        <path
            fill="#e5b400"
            d="M216.934 215.691c-.063 0-.13-.004-.192-.004.059-.117.117-.234.176-.347l.012.23c0 .04.004.078.004.121"
        />
        <g clipPath="url(#c)">
            <path d="M182.457 184.918c.262-7.793 3.375-15.313 8.766-21.176 5.277-5.738 12.52-9.68 20.398-11.097a38.372 38.372 0 0 1 8.07-.579c9.61.32 18.536 4.145 25.133 10.766 6.645 6.668 10.133 15.371 9.828 24.504-.246 7.394-3.015 13.91-8.007 18.84-4.618 4.558-11.028 7.683-18.543 9.035a45.569 45.569 0 0 1-3.078.445 51.14 51.14 0 0 1-7.462.278 50.87 50.87 0 0 1-7.214-.746c-.754-.133-1.5-.282-2.23-.45-6.024-1.363-11.368-3.84-15.552-7.258-6.918-5.652-10.414-13.453-10.109-22.562" />
        </g>
        <path
            fill={bodyColor}
            d="M185.176 185.008c.578-17.309 15.988-30.836 34.426-30.219 18.437.621 32.914 15.149 32.335 32.453-.574 17.309-15.847 26.586-34.285 25.969-18.433-.617-33.054-10.899-32.476-28.203"
        />
        <path d="M195.105 134.148a1.118 1.118 0 0 1 .856-1.273l.062-.012c3.915-.656 7.22.34 9.82 2.957 2.407 2.422 4.095 6.22 4.884 10.977.699 4.219.656 9.058-.122 13.64a1.12 1.12 0 0 1-1.285.915c-.293-.051-.55-.211-.722-.457a1.105 1.105 0 0 1-.188-.833c.707-4.195.774-8.652.18-12.554-.676-4.45-2.172-7.946-4.328-10.11-2.059-2.074-4.711-2.859-7.871-2.328a1.121 1.121 0 0 1-1.286-.922"
        >
        </path>
        <path d="M188.379 133.406a4.44 4.44 0 0 1-.016-.644c.055-1.13.543-2.235 1.41-3.176.997-1.082 2.43-1.875 4.043-2.234.36-.082.73-.141 1.102-.18 1.871-.184 3.691.203 5.121 1.094.39.242.742.511 1.047.808.844.82 1.351 1.828 1.46 2.93a4.4 4.4 0 0 1-.105 1.48 5.133 5.133 0 0 1-1.007 2.016c-.086.11-.18.219-.278.324-.996 1.082-2.433 1.875-4.047 2.238-.359.083-.73.141-1.101.176-1.871.188-3.692-.203-5.121-1.09-1.469-.914-2.36-2.242-2.508-3.742M242.008 134.148a1.12 1.12 0 0 0-.86-1.273l-.058-.012c-3.914-.656-7.219.34-9.82 2.957-2.407 2.422-4.098 6.22-4.883 10.977-.7 4.219-.657 9.058.12 13.64a1.104 1.104 0 0 0 .856.903 1.095 1.095 0 0 0 1.148-.445 1.09 1.09 0 0 0 .192-.833c-.71-4.195-.773-8.652-.18-12.554.676-4.45 2.172-7.946 4.325-10.11 2.062-2.074 4.71-2.859 7.875-2.328a1.123 1.123 0 0 0 1.285-.922" />
        <path d="M248.734 133.406c.02-.215.024-.43.016-.644-.059-1.13-.547-2.235-1.41-3.176-.996-1.082-2.434-1.875-4.043-2.234-.36-.082-.73-.141-1.102-.18-1.875-.184-3.691.203-5.125 1.094a6.07 6.07 0 0 0-1.043.808c-.843.82-1.355 1.828-1.46 2.93-.051.496-.016.992.101 1.48a5.24 5.24 0 0 0 1.008 2.016c.09.11.183.219.281.324.996 1.082 2.434 1.875 4.043 2.238.36.083.73.141 1.105.176 1.872.188 3.688-.203 5.122-1.09 1.468-.914 2.359-2.242 2.507-3.742M218.414 202.09h-.082c-3.332-.028-6.43-1.637-8.957-4.656a1.216 1.216 0 0 1 .145-1.707 1.203 1.203 0 0 1 1.699.148c2.062 2.465 4.527 3.773 7.133 3.797h.058c2.668 0 5.395-1.387 7.496-3.809a1.198 1.198 0 0 1 1.7-.12c.503.437.558 1.198.12 1.706-1.265 1.457-2.71 2.606-4.296 3.406-1.625.82-3.313 1.235-5.016 1.235" />
        <path
            fill="#fff"
            d="M205.871 191.258c-5.777.883-11.289-3.89-12.293-10.645-1-6.754 2.883-12.965 8.66-13.851 5.778-.883 11.29 3.894 12.293 10.648 1 6.75-2.883 12.965-8.66 13.848"
        />
        {/* <animateTransform
            attributeName="transform"
            type="translate"
            values="0,0; 10,0; 0,0"
            dur="2s"
            repeatCount="indefinite"
        /> */}
        <path d="M205.164 186.504c-3.531.539-6.906-2.383-7.52-6.512-.613-4.133 1.766-7.933 5.297-8.472 3.536-.543 6.91 2.378 7.524 6.511.613 4.13-1.766 7.934-5.3 8.473">
            <animateTransform
                attributeName="transform"
                type="translate"
                values="0,0; 2,0; 0,0"
                dur="2s"
                repeatCount="indefinite"
            />
        </path>
        <path
            fill="#fff"
            d="M202.27 176.281c-.262-1.765.75-3.383 2.257-3.613 1.508-.23 2.946 1.012 3.207 2.777.262 1.762-.75 3.38-2.257 3.61-1.512.23-2.946-1.012-3.207-2.774M206.727 180.39c-.102-.68.285-1.296.867-1.386.578-.09 1.129.387 1.23 1.066.102.676-.289 1.297-.867 1.387-.578.09-1.133-.39-1.23-1.066M234.117 191.352c-5.82.5-11.02-4.625-11.59-11.43-.566-6.805 3.703-12.75 9.524-13.25 5.824-.504 11.02 4.625 11.59 11.43.57 6.804-3.703 12.746-9.524 13.25"
        >
        </path>
        <path d="M233.715 186.563c-3.563.304-6.738-2.833-7.09-6.997-.348-4.164 2.266-7.8 5.828-8.105 3.563-.309 6.742 2.828 7.09 6.992.348 4.164-2.266 7.8-5.828 8.11" >
            <animateTransform
                attributeName="transform"
                type="translate"
                values="0,0; 2,0; 0,0"
                dur="2s"
                repeatCount="indefinite"
            />
        </path>
        <path
            fill="#fff"
            d="M231.59 176.281c-.262-1.765.75-3.383 2.258-3.613 1.507-.23 2.945 1.012 3.207 2.777.261 1.762-.75 3.38-2.258 3.61-1.512.23-2.945-1.012-3.207-2.774M236.047 180.39c-.102-.68.285-1.296.867-1.386.578-.09 1.129.387 1.23 1.066.102.676-.289 1.297-.867 1.387-.582.09-1.132-.39-1.23-1.066"
        />
        <g clipPath="url(#d)">
            <g clipPath="url(#e)">
                <path fill="#050000" d="M191.957 131.402h4.738v4.739h-4.738Zm0 0" />
            </g>
        </g>
    </svg>
)
export default BeeBuffer
